import { exportReport2 } from "@/shared/api";
import { ReportManageTaxAccountantTable, ReportRegisterTaxAccountantTable } from "@/entity/report";
import { ReportTwoForm } from "@/features/report";
import { filterValidValuesToObject } from "@/shared/lib";
import { vars } from "@/shared/lib/theme.css";
import { ReportTwoFormType } from "@/shared/model";
import { Button, Column, Row } from "@/shared/ui";
import { createFileRoute, useSearch } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/(auth)/_layout/manage/report-manage-2")({
	component: ReportManageScreen,
	validateSearch: (search: Partial<ReportTwoFormType>): Partial<ReportTwoFormType> => {
		return filterValidValuesToObject<ReportTwoFormType, ReportTwoFormType>(search);
	}
});

function ReportManageScreen() {
	const search = useSearch({
		from: "/(auth)/_layout/manage/report-manage-2",
		select: (search) => search,
		strict: true
	});

	return (
		<Column style={{ width: "100%", gap: vars.size[8], justifyContent: "flex-start", alignItems: "flex-start" }}>
			<ReportTwoForm />

			<Row
				style={{
					justifyContent: "flex-start",
					gap: vars.size[8],

					padding: vars.size[4]
				}}
			>
				<Button
					color="third"
					onClick={() => {
						exportReport2({
							dateRangeValue: {
								from: search.dateFrom,
								to: search.dateTo
							},
							managerIds: search.managerIds
						});
					}}
				>
					{"다운로드"}
				</Button>
			</Row>

			<Suspense>
				<ReportRegisterTaxAccountantTable />
			</Suspense>
			<Suspense>
				<ReportManageTaxAccountantTable />
			</Suspense>
		</Column>
	);
}